import React from "react";
import { SimpleFooter } from "@cmsgov/ds-medicare-gov";
import { useTranslate } from "../helpers";

const Footer: React.FunctionComponent = () => {
  const t = useTranslate();

  return (
    <SimpleFooter
      aboutMedicareLabel={t("footer.about_medicare")}
      medicareGlossaryLabel={t("footer.medicare_glossary")}
      nondiscriminationLabel={t("footer.nondiscrimination_accessibility")}
      privacyPolicyLabel={t("footer.privacy_policy")}
      privacySettingLabel={t("footer.privacy_setting")}
      linkingPolicyLabel={t("footer.linking_policy")}
      usingThisSiteLabel={t("footer.using_this_site")}
      plainWritingLabel={t("footer.plain_writing")}
      websiteInfo={t("footer.website_info")}
    />
  );
};

export default Footer;
